import { InjectionToken, Signal } from '@angular/core';
import { LanguageIso } from '@mkp/shared/models';
import { Observable } from 'rxjs';

/** What the Zendesk widget needs from the host, so this `type:util` library reaches no other domain. */
export interface ZendeskHost {
  /** Emits once the stored GDPR consent has been read. */
  readonly consentLoaded$: Observable<boolean>;
  /** Emits the current functional-consent flag. */
  readonly functionalConsent$: Observable<boolean>;
  /** Emits whether the signed-in user is a back-office user. */
  readonly isBoUser$: Observable<boolean>;
  /** Opens the functional-consent dialog and emits whether consent was granted. */
  requestFunctionalConsent(): Observable<boolean>;
}

const unbound = (token: string) => (): never => {
  throw new Error(`${token} is not bound. Bind it at the app composition root.`);
};

export const ZENDESK_HOST = new InjectionToken<ZendeskHost>('ZENDESK_HOST', {
  factory: unbound('ZENDESK_HOST'),
});

/** The interface language the Help Center URLs follow. */
export const INTERFACE_LANGUAGE = new InjectionToken<Signal<LanguageIso | undefined>>(
  'INTERFACE_LANGUAGE',
  { factory: unbound('INTERFACE_LANGUAGE') }
);
